module.exports = __webpack_public_path__ + "img/b2-5.55fd218.png";